import React from 'react';
import PropTypes from 'prop-types';

import { Button, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

import { AWS_BRAND_SYNC_DOWNLOAD_URL, getURL } from 'lib/networking/endpoints';
import useGet from 'lib/hooks/useGet';

function DownloadSyncButton({ syncId, syncName }) {
  const {
    data: { data: downloadData } = {},
    loading,
    refetch,
  } = useGet(
    getURL(AWS_BRAND_SYNC_DOWNLOAD_URL, { sync_id: syncId }),
    {},
    !syncId, // skip if no syncId
    true, // lazy - prevents automatic loading
  );

  const handleDownloadClick = () => {
    if (downloadData && downloadData.presigned_url) {
      // If we already have the URL, use it directly
      const { presigned_url, file_name } = downloadData;
      const link = document.createElement('a');
      link.href = presigned_url;
      link.download = file_name || `sync_${syncId}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      // Fetch the presigned URL and then trigger download
      refetch(response => {
        if (response.status === 200 && response.data?.data) {
          const { presigned_url, file_name } = response.data.data;
          const link = document.createElement('a');
          link.href = presigned_url;
          link.download = file_name || `sync_${syncId}.csv`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      });
    }
  };

  return (
    <Button
      variant="outline-primary"
      size="sm"
      onClick={handleDownloadClick}
      disabled={loading}
      className="d-flex align-items-center gap-1"
    >
      {loading ? (
        <>
          <Spinner animation="border" role="status" size="sm" />
          Loading...
        </>
      ) : (
        <>
          <FontAwesomeIcon icon={faDownload} className="mr-1" />
          Download
        </>
      )}
    </Button>
  );
}

DownloadSyncButton.propTypes = {
  syncId: PropTypes.number.isRequired,
  syncName: PropTypes.string,
};

export default DownloadSyncButton;
